import { GOOGLE_ANALYTICS_4_TRACKING_ID } from 'config'
import ReactGA from 'react-ga4'

export function initializeGoogleAnalytics() {
  if (!GOOGLE_ANALYTICS_4_TRACKING_ID) {
    console.error('[google-analytics] Initialize failed: tracking id must be provided')
    return
  }

  ReactGA.initialize(GOOGLE_ANALYTICS_4_TRACKING_ID)
}
